export default __webpack_public_path__ + "f4e4ec3d8996db8fd970fadcba561f96.png";